import { COUPON_TYPE } from "@up/data";

import { useCart } from "../CartContext";
import { SummaryTable } from "../SummaryTable";

export const PaymentTotals = () => {
  const cart = useCart();
  if (!cart.data) return null;

  const { summary, coupon } = cart.data;

  return (
    <div className="payment-totals">
      <div className="opacity-60">
        <SummaryTable label="Subtotal:" price={summary.formattedRetailPrice} />
      </div>

      {summary.formattedDiscountAmount ? (
        <div data-testid="payment-coupon-info" className="text-red-600">
          {coupon?.type === COUPON_TYPE.PARTIAL_SCHOLARSHIP ||
          coupon?.type === COUPON_TYPE.FULL_SCHOLARSHIP ? (
            <SummaryTable
              label="Scholarship Amount:"
              price={`- ${summary.formattedDiscountAmount}`}
              type={coupon.type === COUPON_TYPE.FULL_SCHOLARSHIP ? "" : "usd"}
            />
          ) : (
            <SummaryTable
              label="Discount Amount:"
              price={`- ${summary.formattedDiscountAmount}`}
            />
          )}
        </div>
      ) : null}

      <div className="font-bold">
        <SummaryTable label="Total:" price={summary.formattedPriceToPay} />
      </div>
    </div>
  );
};
